<template>
  <div id="app">
    <el-container>
      <el-header height="80px" style="z-index: 5">
        <Nav @left_show="left_show" @right_show="right_show" ref="son"></Nav>
      </el-header>
      <MobileNav :left="left" :right="right" @reset="reset"></MobileNav>
      <el-main class="content">
        <announcement></announcement>
        <router-view/>
      </el-main>
      <el-backtop></el-backtop>
      <el-footer height="100%"><foot></foot></el-footer>
    </el-container>
  </div>
</template>

<script>
import Nav from './components/base/header/Nav'
import MobileNav from './components/base/header/MobileNav'
import foot from './components/base/foot'
import announcement from './components/widget/announcement'
export default {
  name: 'App',
  data () {
    return {
      left: true,
      right: true,
      alert: ''
    }
  },
  components: {
    Nav,
    MobileNav,
    foot,
    announcement
  },
  methods: {
    left_show (Boolean) {
      this.left = Boolean
    },
    right_show (Boolean) {
      this.right = Boolean
    },
    reset () {
      this.left = true
      this.right = true
      this.$refs.son.left_show = true
      this.$refs.son.right_show = true
    }
  }
}

</script>

<style>
  /*html {*/
    /*filter: grayscale(100%);*/
    /*-webkit-filter: grayscale(100%);*/
    /*-moz-filter: grayscale(100%);*/
    /*-ms-filter: grayscale(100%);*/
    /*-o-filter: grayscale(100%);*/
    /*-webkit-filter: grayscale(1);*/
  /*}*/
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }
  body {
    background-color: rgb(242, 242, 242) !important;
    margin: 0;
  }
  .el-message{
    min-width: 10%!important;
  }
  .el-card {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #666!important;
  }
  .el-header {
    position: fixed;
    display: flex;
    width: 100%;
    top: 0;
    z-index: 1;
    background-color: #fff;
    border-top: 3px solid #f39;
    border-bottom: 1px solid #f2f2f2;
    padding: 0;
  }

  .el-footer {
    width: 100%;
    background: #fff;
    color: #666;
  }

  .el-main {
    margin-top: 80px!important;
    padding: 10px!important;
  }
  @media (min-width: 576px) {
    .content {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    .content {
      max-width: 720px;
    }
  }

  @media (min-width: 992px) {
    .content {
      max-width: 960px;
    }
  }

  @media (min-width: 1200px) {
    .content {
      max-width: 1140px;
    }
  }
  .content {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
  .text-center{
    text-align: center;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: 15px;
    margin-left: 15px;
  }
  .el-card{
    margin-bottom: .5rem!important;
    margin-top: .5rem!important;
  }

  .c-btn{
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px
  }
  .link{
    color: #f39;
    text-decoration:none;
  }
  .C-PageLoading{
    display:flex!important;
    justify-content:center!important;
    padding:150px 0;
  }
  .spinner-grow {
    display:inline-block;
    width:2rem;
    height:2rem;
    vertical-align:text-bottom;
    background-color:currentColor;
    border-radius:50%;
    opacity:0;
    -webkit-animation:spinner-grow .75s linear infinite;
    animation:spinner-grow .75s linear infinite
  }
  .text-primary {
    color:#f39!important
  }
  @-webkit-keyframes spinner-grow {
    0% {
      transform:scale(0)
    }
    50% {
      opacity:1;
      transform:none
    }
  }
  @keyframes spinner-grow {
    0% {
      transform:scale(0)
    }
    50% {
      opacity:1;
      transform:none
    }
  }
  html {
    overflow-y: scroll;
  }

  .G-Title{
    font-size: 16px;
    text-align: left;
    padding: 10px;
    font-weight: bold;
  }
  .el-card__body{
    padding: 10px;
  }
  a:link,a:visited{
    text-decoration:none;
  }
  .ant-tag {
    color: #f5222d;
    display: inline-block;
    margin: 0 8px 0 0;
    padding: 0 7px;
    font-size: 12px;
    line-height: 20px;
    background: #fff1f0;
    border: 1px solid #ffa39e;
    width: 24px;
  }
  .m-10{
    margin-top:10px;
    margin-bottom: 10px
  }
  @media (max-width: 480px) {
    .el-dialog {
      width: 90% !important;
    }
    .el-message-box {
      width: 90% !important;
    }
  }
  @media (min-width: 480px) {
    .el-dialog {
      width: 450px !important;
    }
  }
  .Profile {
    font-size: 14px;
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
  }
  ::selection {
    color: #fff;
    background: #f39;
  }
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  @media (min-width: 992px) {
    .LeftPart {
      padding-right: .5rem;
      flex: 0 0 66.66667%;
      max-width: 66.66667%;
    }
  }

  .LeftPart {
    position: relative;
    width: 100%;
  }
  @media (min-width: 992px) {
    .RightPart {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
  }
  .RightPart{
    padding: 0!important;
    position: relative;
    width: 100%;
  }
  .InfoHead {
    display: flex !important;
    padding-bottom: .3rem !important;
    justify-content: space-between !important;
  }
  p {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .el-loading-spinner {
    top:80px !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue